<template>
    <form @submit.prevent="validateForm($event)" enctype="multipart/form-data">
        <div class="form-row">
            <div class="form-group my-1">
                 <select @change.prevent="$emit('onSetAddres', $event)" class="custom-input">
                    <option selected disabled>Seleccione una dirección</option>
                    <option v-for="address in addresses" :key="address.id" v-bind="address">{{address.address_line_1 + ", " + address.address_line_2 + ", " + address.city + ", " + address.state + ", " + address.postal_code}}</option>
                 </select>
            </div>
        </div>
        <div class="form-row">
            <LengthInput
                class="form-group"
                v-model="form.destination_address.line_1"
                label="Dirección completa"
                placeholder="Dirección"
                name="destination_address[line_1]"
                :isInvalid="formErrors.includes('line_1')"
                @focus="fieldFormFocus('destination_address[line_1]')"
            ></LengthInput>

            <LengthInput
                class="form-group"
                v-model="form.destination_address.line_2"
                label="Colonia"
                placeholder="Colonia"
                name="destination_address[line_2]"
                :isInvalid="formErrors.includes('line_2')"
                @focus="fieldFormFocus('destination_address[line_2]')"
            ></LengthInput>
        </div>
        <div class="form-row mt-1">
            <LengthInput
                class="form-group"
                v-model="form.destination_address.line_3"
                label="Referencia"
                placeholder="Referencia"
                name="destination_address[line_3]"
                :isInvalid="formErrors.includes('line_3')"
                @focus="fieldFormFocus('destination_address[line_3]')"
            ></LengthInput>
            
            <div class="form-group">
                <label class="font-semibold">C.P (inalterable)</label>
                <input
                    id="postal_code"
                    name="destination_address[postal_code]"
                    v-model="form.destination_address.postal_code"
                    readonly
                    :class="['custom-input', {'is-invalid': formErrors.includes('destination')}]"
                    placeholder="Código postal"
                    @focus="fieldFormFocus('destination_address[postal_code]')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <LengthInput
                class="form-group"
                v-model="form.destination_address.city"
                label="Ciudad"
                placeholder="Ciudad"
                name="destination_address[city]"
                :isInvalid="formErrors.includes('city')"
                @focus="fieldFormFocus('destination_address[city]')"
            ></LengthInput>
            <div class="form-group">
                <label class="font-semibold">Estado</label>
                <input
                    id="state"
                    name="destination_address[state]"
                    v-model="form.destination_address.state"
                    :class="['custom-input', {'is-invalid': formErrors.includes('state')}]"
                    placeholder="Estado"
                    @focus="fieldFormFocus('destination_address[state]')"
                >
            </div>
        </div>
    <div class="form-row mt-1">
            <LengthInput
                class="form-group"
                v-model="form.recipient_name"
                label="Destinatario"
                placeholder="Nombre"
                name="recipient_name"
                :isInvalid="formErrors.includes('recipient_name')"
                @focus="fieldFormFocus('recipient_name')"
            ></LengthInput>
            
            <LengthInput
                class="form-group"
                v-model="form.recipient_company"
                label="Empresa del destinatario"
                placeholder="Empresa"
                name="recipient_company"
                :isInvalid="formErrors.includes('recipient_company')"
                @focus="fieldFormFocus('recipient_company')"
            ></LengthInput>
        </div>
        <p class="font-md font-bold my-1">Información del paquete</p>
        <div class="form-row mt-1">
            <div class="form-group">
                <label class="font-semibold">Peso</label>
                <input
                    name="product_weight"
                    readonly
                    v-model="form.product_weight"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_weight')}]"
                    placeholder="Peso"
                    @focus="fieldFormFocus('product_weight')"
                >
            </div>
            <div class="form-group">
                <label class="font-semibold">Ancho</label>
                <input
                    name="product_width"
                    readonly
                    v-model="form.product_width"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_width')}]"
                    placeholder="Ancho"
                    @focus="fieldFormFocus('product_width')"
                >
            </div>
            <div class="form-group">
                <label class="font-semibold">Largo</label>
                <input
                    name="product_length"
                    readonly
                    v-model="form.product_length"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_length')}]"
                    placeholder="Largo"
                    @focus="fieldFormFocus('product_length')"
                >
            </div>
            <div class="form-group">
                <label class="font-semibold">Alto</label>
                <input
                    name="product_height"
                    readonly
                    v-model="form.product_height"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_height')}]"
                    placeholder="Alto"
                    @focus="fieldFormFocus('product_height')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <label class="font-semibold">Costo de la compra</label>
                <input
                    name="product_cost"
                    readonly
                    v-model="form.product_cost"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_cost')}]"
                    placeholder="Costo"
                    @focus="fieldFormFocus('product_cost')"
                >
            </div>
            <div class="form-group">
                <label class="font-semibold">Link de compra</label>
                <input
                    name="product_url"
                    v-model="form.product_url"
                    :required="!isHuipix"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_url')}]"
                    placeholder="Link"
                    @focus="fieldFormFocus('product_url')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <label class="font-semibold">Marca del producto</label>
                <input
                    name="product_brand"
                    v-model="form.product_brand"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_brand')}]"
                    placeholder="Marca"
                    @focus="fieldFormFocus('product_brand')"
                >
            </div>
            <div class="form-group">
                <label class="font-semibold">No. de rastreo</label>
                <input
                    name="international_tracking_number"
                    v-model="form.international_tracking_number"
                    :required="!isHuipix"
                    :class="['custom-input', {'is-invalid': formErrors.includes('international_tracking_number')}]"
                    placeholder="No. de rastreo"
                    @focus="fieldFormFocus('international_tracking_number')"
                >
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group">
                <label class="font-semibold">Descripción</label>
                <textarea
                    name="product_description"
                    v-model="form.product_description"
                    :class="['custom-input', {'is-invalid': formErrors.includes('product_description')}]"
                    placeholder="Descripción del producto"
                    @focus="fieldFormFocus('product_description')"
                ></textarea>
            </div>
        </div>

        <dropzone-uploader
            :modelValue="files"
            @update:modelValue="$emit('update:files', $event)"
            :maxFiles="50"
            spanText="Elige uno o varios archivos (.jpg, .jpeg, .png, .pdf)"
            acceptedFiles=".jpg,.jpeg,.png,.pdf"
            showFileContent
        ></dropzone-uploader>

        <p class="danger-color" v-for="e in error">{{ e[0] }}</p>

        <p v-if="formErrors.includes('chboxAgree')" class="danger-color">Por favor acepte las condiciones de reempaquetado.</p>
        <p v-if="formErrors.includes('chboxAgree2')" class="danger-color">Por favor acepte las posibles recalculaciones aduanales</p>
          
        <div class="form-row mt-1">
            <div class="form-group-row">
                <input v-model="form.add_address_book" name="add_address_book" id="chbox-add-address" type="checkbox" class="custom-checkbox">
                <label for="chbox-add-address" class="font-semibold font-sm muted-color">Agregar dirección a la libreta de direcciones</label>
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group-row">
                <input v-model="form.add_insurance" id="chbox-insurance" type="checkbox" class="custom-checkbox">
                <label for="chbox-insurance" class="font-semibold font-sm muted-color">Desea asegurar el artículo por: <b>${{form.insurance}}</b></label>
            </div>
        </div>
        <div class="display-flex justify-content-between sm-flex-column my-1">
            <div class="form-group-row">
                <input id="chbox-agree" v-model="form.chboxAgree" name="chboxAgree" type="checkbox" class="custom-checkbox" checked>
                <label for="chbox-agree" class="font-semibold font-sm muted-color align-self-center">Estoy de acuerdo con las condiciones de reempaquetado.</label>
            </div>
        </div>
        <div class="display-flex justify-content-between sm-flex-column my-1">
            <div class="form-group-row">
                <input id="chbox-agree2" v-model="form.chboxAgree2" name="chboxAgree2" type="checkbox" class="custom-checkbox" checked>
                <label for="chbox-agree2" class="font-semibold font-sm muted-color align-self-center">Estoy de acuerdo con que la aduana puede recalcular el valor del paquete en cualquier momento, lo cual afectaría la cotización en el futuro.</label>
            </div>
            
            <div class="text-center">
                <button class="btn-danger px-5" type="submit">Guardar</button>
            </div>
        </div>
    </form>
</template>

<script>
import DropzoneUploader from '../dropzone-uploader.vue';
import LengthInput from '../LengthInput.vue';

export default {
    components: {
        LengthInput,
        DropzoneUploader
    },
    props: {
        form: Object,
        files: Array,
        addresses: Array,
        quotResponse: Object,
        quotRequest: Object,
        error: Array,
        multipleOrderIds: [null, Array]
    },
    data () {
        return {
            formErrors: [],
            isHuipix: window?.location?.hostname === 'importaciones.huipixenvios.com.mx'
        }
    },
    methods: {
        fieldFormFocus(field) {
            this.$emit('fieldFormFocus', field);
        },
        validateForm() {
            if(!this.isvalidForm()) return;

            this.$emit('submitForm', this.prepareForm())
        },
        prepareForm () {
            const formData = new FormData();
            formData.append('subtotal', this.quotResponse.totalAmount)

            for (const key in this.form.destination_address) {
                formData.append(`destination_address[${key}]`, this.form.destination_address[key]);
            }

            const dimensionFields = ['product_weight', 'product_width', 'product_length', 'product_height'];
            for (const key in this.form) {
                if (key !== 'destination_address') {
                    const value = dimensionFields.includes(key)
                        ? this.roundUpDimensionValue(this.form[key])
                        : this.form[key];
                    formData.append(key, value);
                }
            }

            this.files.forEach((file) => {
                formData.append("files[]", file);
            })

            formData.append("quotation_reply", JSON.stringify(this.quotResponse))
            formData.append("package_requested", JSON.stringify(this.quotRequest))

            if (this.multipleOrderIds) {
                this.multipleOrderIds.forEach((id) => {
                    formData.append("group_order_ids[]", id)
                })
            }
            return formData
        },
        roundUpDimensionValue(value) {
            if (value === null || value === undefined || value === '') return value;
            const numeric = Number(value);
            if (Number.isNaN(numeric)) return value;
            return Math.ceil(numeric);
        },
        isvalidForm(){
            this.formErrors = [];
            for (const field in this.form.destination_address)
                if(!this.form.destination_address[field] || !this.form.destination_address[field] === '') this.formErrors.push(field);

            for(const field in this.form) {
                if (this.isHuipix && (field === 'product_url' || field === 'international_tracking_number')) continue
                let value = this.form[field]
                if (value === 0) continue
                if (value === 0 && field === 'insurance') continue
                if(!value && field !== 'add_insurance' && field !== 'add_address_book') this.formErrors.push(field);
            }

            return this.formErrors == 0;
        },
    }
}
</script>
